export const SEARCH_SOCIAL_PLATFORMS = ['google_ads', 'facebook_ads', 'linkedin_ads'] as const;

export function isSearchSocialPlatform(platform?: string | null): boolean {
  return Boolean(platform && SEARCH_SOCIAL_PLATFORMS.includes(platform as typeof SEARCH_SOCIAL_PLATFORMS[number]));
}

export function defaultMarginPct(platform?: string | null): number {
  return isSearchSocialPlatform(platform) ? 15 : 0;
}

export function computeNetBudget(grossBudget: number, marginPct: number): number {
  if (!Number.isFinite(grossBudget) || !Number.isFinite(marginPct)) {
    return 0;
  }
  return grossBudget * (1 - marginPct / 100);
}
